/* eslint-disable react-hooks/exhaustive-deps */
import InputForm from "../../../components/inputs/InputForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { Loader, toaster } from "rsuite";
import { useEffect, useState } from "react";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { TipoDocumento } from "../../../types/filemanager/TipoDoc";

const formSchema = Yup.object().shape({
  name: Yup.string().required("Ingrese un nombre"),
});

export default function Form({
  setOpen,
  selected,
}: {
  setOpen: any;
  selected?: TipoDocumento;
}) {
  const [loading, setLoading] = useState<boolean>(false);

  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: { name: "" },
    validationSchema: formSchema,
    onSubmit: (values) => {
      swalAction(
        save,
        `${selected ? "Editar" : "Guardar"} Tipo de Folder`,
        `¿Desea ${selected ? "editar" : "guardar"} este tipo de folder?`,
        "question"
      );
    },
    onReset: () => {
      setOpen(false);
    },
  });

  function onChange({ target }: { target: any }) {
    setFieldValue(target.name, target.value);
  }

  useEffect(() => {
    if (selected) setValues({ ...selected }, true);
  }, []);

  async function save() {
    const method = selected ? "PUT" : "POST";
    const rute = selected ? `/${selected._id}` : "";
    setLoading(true);
    const res = await peticionBack(
      values,
      "/tiposcarpeta" + rute,
      method,
      true,
      toaster
    );
    if (res) handleReset(null);
    setLoading(false);
  }

  return (
    <form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col xs={12} md={12}>
          <InputForm
            label="Nombre"
            name="name"
            type="text"
            value={values.name}
            touched={touched.name}
            error={errors.name}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
      </Row>

      <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
        <Button variant="danger" type="reset">
          Cancelar
        </Button>
        <Button variant="success" type="submit">
          Guardar
        </Button>
      </div>

      {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
    </form>
  );
}
